/**
 * True when the stored user has the admin role.
 *
 * AdminGuard and the portal header both use this, so the "Admin dashboard"
 * link only shows for users the guard will let in.
 */
export function isAdminUser(user: any): boolean {
  const roles = user?.roleProtectedObjectList;
  return (
    Array.isArray(roles) &&
    roles.some(
      (role: any) =>
        typeof role?.roleName === 'string' &&
        role.roleName.trim().toLowerCase() === 'admin'
    )
  );
}
